module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0129.jpg?v=59e5f7bc";